<template>
  <Breadcrumbs
      title="Lorry Target"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Lorry Target', path: '/lorry-target' },
    ]"
  />
  
  <div class="container-fluid">
    <div class="row project-cards">
      <lorryTarget/>
    </div>
  </div>
</template>
  
<script>
import lorryTarget from './lorry_target_form.vue'
export default {
  name: 'indexList',
  components: {
    lorryTarget,
  },
}
</script>